import { MODULE_KEYS, resolveEnabledModules, type ModuleKey } from '@garage/shared';
import { useOptionalActiveMe } from './me.js';

/**
 * Modules actifs du garage (vague 7) : ceux renvoyés par `auth.me` (`active.enabledModules`, ou
 * `support.enabledModules` en session support, repris par `supportActiveMe`). Hors espace garage (aucun
 * utilisateur actif), les valeurs par défaut du registre du contrat. L'interface masque ce qui dépend d'un
 * module inactif ; le serveur refuse de toute façon (403 `module_disabled`).
 */
export function enabledModulesOf(list: readonly ModuleKey[] | undefined): ReadonlySet<ModuleKey> {
  if (list) return new Set(list);
  const defaults = resolveEnabledModules(null);
  return new Set(MODULE_KEYS.filter((k) => defaults.has(k)));
}

export function useEnabledModules(): ReadonlySet<ModuleKey> {
  const me = useOptionalActiveMe();
  return enabledModulesOf(me?.active.enabledModules);
}

export function useModuleEnabled(key: ModuleKey): boolean {
  return useEnabledModules().has(key);
}
